import React, { FC, useState } from 'react';
import { BlockPicker, BlockPickerProps } from 'react-color';
import cx from 'classnames';
import { Box, FormHelperText, makeStyles, Popover } from '@material-ui/core';
import { colors as themeColors } from 'common/ui/theme/default';

const useStyles = makeStyles(() => ({
  picker: {
    display: 'flex',
    alignItems: 'center',
  },
  pickerBtn: {
    width: '16px',
    height: '16px',
    borderRadius: '50%',
    cursor: 'pointer',
  },
  pickerBtnDisabled: {
    pointerEvents: 'none',
    cursor: 'default',
  },
  pickerContainer: {
    '&>div:nth-last-of-type(n+2)': {
      display: 'none!important',
    },
    '& span>div': {
      borderRadius: '100%!important',
    },
  },
}));

interface IColorPicker extends BlockPickerProps {
  value: any;
  onChange: (value) => void;
  className?: string;
  error?: boolean;
  helperText?: JSX.Element | string;
  disabled?: boolean;
}

const ColorPicker: FC<IColorPicker> = ({
  onChange,
  value,
  className,
  error,
  helperText,
  disabled = false,
}) => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);

  const colors = [
    themeColors.colorPicker.defaultColor,
    themeColors.colorPicker.freshGreen,
    themeColors.colorPicker.emerald,
    themeColors.colorPicker.teal,
    themeColors.colorPicker.brightCyan,
    themeColors.colorPicker.skyBlue,
    themeColors.colorPicker.clearSky,
    themeColors.colorPicker.deepSky,
    themeColors.colorPicker.blue,
    themeColors.colorPicker.softBlue,
    themeColors.colorPicker.indigo,
    themeColors.colorPicker.softIndigo,
    themeColors.colorPicker.violet,
    themeColors.colorPicker.fuchsia,
    themeColors.colorPicker.lavender,
    themeColors.colorPicker.deepPink,
    themeColors.colorPicker.pink,
    themeColors.colorPicker.rose,
    themeColors.colorPicker.forestGreen,
    themeColors.colorPicker.slate,
    themeColors.colorPicker.red,
    themeColors.colorPicker.orange,
    themeColors.colorPicker.amber,
    themeColors.colorPicker.goldenrod,
    themeColors.colorPicker.darkAmber,
  ];

  const onOpenPicker = (e: React.MouseEvent<any>): void => {
    setAnchorEl(e.currentTarget);
  };

  const onClosePicker = () => {
    setAnchorEl(null);
  };

  const onChangeColor = updatedColor => {
    onChange(updatedColor.hex);
  };

  return (
    <Box className={cx(classes.picker, className)}>
      <Box
        className={cx(classes.pickerBtn, { [classes.pickerBtnDisabled]: disabled })}
        style={{ backgroundColor: value }}
        onClick={onOpenPicker}
      />

      <Popover
        id="event-color-popover"
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        onClose={onClosePicker}
      >
        <BlockPicker
          className={classes.pickerContainer}
          color={value}
          onChange={onChangeColor}
          onChangeComplete={() => {
            setAnchorEl(null);
          }}
          styles={{
            default: {
              card: {
                width: '190px',
              },
              input: {
                display: 'none',
              },
              body: {
                paddingBottom: '10px',
                paddingTop: '20px',
                paddingLeft: '20px',
                paddingRight: '10px',
              },
            },
          }}
          colors={colors}
        />
      </Popover>

      {!!error && <FormHelperText error>{helperText}</FormHelperText>}
    </Box>
  );
};

export default ColorPicker;
